import { render } from "./CollectionDetails.vue?vue&type=template&id=e9e7eea2"
import script from "./CollectionDetails.vue?vue&type=script&lang=js"
export * from "./CollectionDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__